import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const FullLoader = ({ text = "Memuat..." }) => (
  <div data-testid="full-loader" className="min-h-screen flex items-center justify-center gap-3 text-muted-foreground">
    <Loader2 className="h-5 w-5 animate-spin" />
    <span className="text-sm">{text}</span>
  </div>
);

export const ProtectedRoute = ({ children, adminOnly, staffOnly }) => {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (staffOnly && user.role === "polda") return <Navigate to="/dashboard" replace />;
  return children;
};
